// Registers the production service worker and applies updates immediately.
// CRA's generated worker listens for { type: 'SKIP_WAITING' } and claims clients.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
)

const UPDATE_INTERVAL_MS = 60 * 1000

let refreshing = false

const reloadOnce = () => {
  if (refreshing) return
  refreshing = true
  window.location.reload()
}

const activateWaitingWorker = (registration) => {
  const waiting = registration?.waiting
  if (!waiting) return false
  waiting.postMessage({ type: 'SKIP_WAITING' })
  return true
}

export function register(config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
  if (publicUrl.origin !== window.location.origin) {
    return
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`

    // Only reload when a new worker replaces one that was already controlling the page.
    let hadController = Boolean(navigator.serviceWorker.controller)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController) {
        hadController = true
        return
      }
      reloadOnce()
    })

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config)
    } else {
      registerValidSW(swUrl, config)
    }
  })
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl, { updateViaCache: 'none' })
    .then((registration) => {
      const promptUpdate = (worker) => {
        if (!worker) return
        worker.addEventListener('statechange', () => {
          if (worker.state === 'installed' && navigator.serviceWorker.controller) {
            activateWaitingWorker(registration)
            if (config && config.onUpdate) {
              config.onUpdate(registration)
            }
          } else if (worker.state === 'activated' && config && config.onSuccess) {
            config.onSuccess(registration)
          }
        })
      }

      // A worker may already be waiting from a previous visit.
      if (navigator.serviceWorker.controller && registration.waiting) {
        activateWaitingWorker(registration)
      }

      if (registration.installing) {
        promptUpdate(registration.installing)
      }

      registration.addEventListener('updatefound', () => {
        promptUpdate(registration.installing)
      })

      const checkForUpdate = () => {
        registration.update().catch(() => {})
      }

      checkForUpdate()
      window.setInterval(checkForUpdate, UPDATE_INTERVAL_MS)
      window.addEventListener('focus', checkForUpdate)
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          checkForUpdate()
        }
      })
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error)
    })
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type')
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload()
          })
        })
      } else {
        registerValidSW(swUrl, config)
      }
    })
    .catch(() => {})
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister()
      })
      .catch((error) => {
        console.error(error.message)
      })
  }
}
